function Powerpoint({ className = 'h-6 w-6' }) {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.99902 1C7.14417 1.00541 5.36683 1.74464 4.05525 3.05623C2.74367 4.36781 2.00443 6.14515 1.99902 8L10.8675 9.8685L8.99902 1Z'
        fill='#ED6C47'
      />
      <path
        d='M8.99902 1C10.8539 1.00541 12.6312 1.74464 13.9428 3.05623C15.2544 4.36781 15.9936 6.14515 15.999 8L12.499 10.379L8.99902 8V1Z'
        fill='#FF8F6B'
      />
      <path
        d='M8.99902 15C10.8539 14.9946 12.6312 14.2554 13.9428 12.9438C15.2544 11.6322 15.9936 9.85485 15.999 8H1.99902C2.00443 9.85485 2.74367 11.6322 4.05525 12.9438C5.36683 14.2554 7.14417 14.9946 8.99902 15Z'
        fill='#D35230'
      />
      <path
        opacity='0.1'
        d='M8.33188 3.5H3.65188C2.50892 4.84667 1.921 6.57767 2.00735 8.34188C2.0937 10.1061 2.84787 11.7714 4.11688 13H8.33188C8.50857 12.9996 8.67792 12.9293 8.8029 12.8044C8.92789 12.6795 8.99835 12.5102 8.99888 12.3335V4.1665C8.99835 3.98981 8.92789 3.82051 8.8029 3.69562C8.67792 3.57073 8.50857 3.5004 8.33188 3.5Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.83172 4H3.26872C2.23806 5.46238 1.81077 7.26578 2.07571 9.03514C2.34065 10.8045 3.27742 12.4036 4.69122 13.5H7.83222C8.00883 13.4995 8.17805 13.4291 8.30293 13.3042C8.4278 13.1793 8.49819 13.0101 8.49872 12.8335V4.6665C8.49819 4.48981 8.42773 4.32051 8.30275 4.19562C8.17776 4.07073 8.00841 4.0004 7.83172 4Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.83166 4H3.26866C2.38089 5.2587 1.93673 6.7768 2.00607 8.31552C2.0754 9.85424 2.65428 11.3262 3.65166 12.5H7.83216C8.00876 12.4995 8.17799 12.4291 8.30286 12.3042C8.42774 12.1793 8.49813 12.0101 8.49866 11.8335V4.6665C8.49813 4.48981 8.42767 4.32051 8.30269 4.19562C8.1777 4.07073 8.00835 4.0004 7.83166 4Z'
        fill='black'
      />
      <path
        opacity='0.2'
        d='M7.33166 4H3.26866C2.38089 5.2587 1.93673 6.7768 2.00607 8.31552C2.0754 9.85424 2.65428 11.3262 3.65166 12.5H7.33216C7.50876 12.4995 7.67799 12.4291 7.80286 12.3042C7.92774 12.1793 7.99813 12.0101 7.99866 11.8335V4.6665C7.99813 4.48981 7.92767 4.32051 7.80269 4.19562C7.6777 4.07073 7.50835 4.0004 7.33166 4Z'
        fill='black'
      />
      <path
        d='M0.665523 4H7.33252C7.50929 4 7.67882 4.07022 7.80381 4.19521C7.9288 4.32021 7.99902 4.48973 7.99902 4.6665V11.3335C7.99902 11.5103 7.9288 11.6798 7.80381 11.8048C7.67882 11.9298 7.50929 12 7.33252 12H0.665523C0.488757 12 0.31923 11.9298 0.194237 11.8048C0.0692438 11.6798 -0.000976562 11.5103 -0.000976562 11.3335L-0.000976562 4.6665C-0.000976562 4.48973 0.0692438 4.32021 0.194237 4.19521C0.31923 4.07022 0.488757 4 0.665523 4Z'
        fill='#C43E1C'
      />
      <path
        d='M3.99752 5.49983C4.48986 5.46668 4.97799 5.60931 5.37502 5.90233C5.53786 6.04763 5.66552 6.22807 5.74833 6.42999C5.83115 6.63191 5.86695 6.85003 5.85302 7.06783C5.85848 7.35062 5.77583 7.62811 5.61652 7.86183C5.45437 8.12014 5.221 8.32607 4.94452 8.45483C4.62843 8.60159 4.28295 8.67411 3.93452 8.66683H2.97952V10.4998H1.99902V5.49983H3.99752ZM2.97902 7.84133H3.82252C4.08997 7.861 4.35535 7.78202 4.56852 7.61933C4.65323 7.56484 4.72146 7.48827 4.76586 7.39787C4.81027 7.30747 4.82917 7.20667 4.82052 7.10633C4.82052 6.55333 4.49836 6.27683 3.85402 6.27683H2.97902V7.84133Z'
        fill='#F9F7F7'
      />
    </svg>
  )
}
export default Powerpoint
